/* LOADING */
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const ERROR_LOADING = "ERROR_LOADING";

/* CART */
export const GET_CART_REQUEST = "GET_CART_REQUEST";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_FAILURE = "GET_CART_FAILURE"

/* ORDER ITEMS */
export const SET_FORMATTED_ORDER_ITEMS = "SET_FORMATTED_ORDER_ITEMS";

/* SHIPPING */ 
export const GET_ENABLED_SHIPPING_MODES_REQUEST = "GET_ENABLED_SHIPPING_MODES_REQUEST";
export const GET_ENABLED_SHIPPING_MODES_SUCCESS = "GET_ENABLED_SHIPPING_MODES_SUCCESS";
export const GET_ENABLED_SHIPPING_MODES_FAILURE = "GET_ENABLED_SHIPPING_MODES_FAILURE";
export const SET_SELECTED_SHIPPING_MODE = "SET_SELECTED_SHIPPING_MODE";

/* CONFIG */
export const SAVE_CONFIG = "SAVE_CONFIG";
export const OPEN_MODAL = "OPEN_MODAL";
export const SET_IS_MOBILE = "SET_IS_MOBILE";

/* CUSTOMER ADDRESS */
export const GET_ADDRESS = "GET_ADDRESS";
export const GET_ADDRESS_SUCCESS = "GET_ADDRESS_SUCCESS";
export const GET_ADDRESS_FAILURE = "GET_ADDRESS_FAILURE";
export const SET_ADDRESS = "SET_ADDRESS";
export const GET_ALL_BILLING_ADDRESSES = "GET_ALL_BILLING_ADDRESSES";
export const SET_EMAIL = "SET_EMAIL";

/* PROMO CODES */
export const GET_PROMO_CODES_SUCCESS = "GET_PROMO_CODES_SUCCESS";
export const GET_PROMO_CODES_FAILURE = "GET_PROMO_CODES_FAILURE";

/* FAQ */
export const SET_FAQ_SUCCESS = "SET_FAQ_SUCCESS";
export const SET_FAQ_FAILURE = "SET_FAQ_FAILURE";

/* CART UPSELL DETAILS */
export const SET_CART_UPSELL_DETAILS_SUCCESS = "SET_CART_UPSELL_DETAILS_SUCCESS";
export const SET_CART_UPSELL_DETAILS_FAILURE = "SET_CART_UPSELL_DETAILS_FAILURE";

/* ORDER */
export const SET_ORDER_ID = "SET_ORDER_ID";

/* SESSION */
export const SET_SHOW_SESSION_MODAL = "SET_SHOW_SESSION_MODAL";
export const SET_SHOW_GENERIC_ERROR_MODAL = "SET_SHOW_GENERIC_ERROR_MODAL";

export const SET_SHOW_PROMO_CODE_FEEDBACK = 'SET_SHOW_PROMO_CODE_FEEDBACK';

export const SET_PERSON = 'SET_PERSON';

export const SET_INSURANCE = 'SET_INSURANCE';
export const SET_INSURANCE_ERROR = 'SET_INSURANCE_ERROR';

/* ESPOT TYP */
export const GET_ESPOT_TYP_SUCCESS = 'GET_ESPOT_TYP_SUCCESS';
export const GET_ESPOT_TYP_FAILURE = 'GET_ESPOT_TYP_FAILURE';

export const SET_DISABLE_NAVIGATION = 'SET_DISABLE_NAVIGATION';

/* ESPOT FOOTER */
export const GET_ESPOT_FOOTER_SUCCESS = 'GET_ESPOT_FOOTER_SUCCESS';
export const GET_ESPOT_FOOTER_FAILURE = 'GET_ESPOT_FOOTER_FAILURE';

export const SET_CLIENT_SIDE_NAVIGATION = 'SET_CLIENT_SIDE_NAVIGATION';

/* BOSS */
export const OPEN_MODAL_BOSS = 'OPEN_MODAL_BOSS';
export const PHYSICAL_STORES = 'PHYSICAL_STORES';
export const RADIUS = 'RADIUS';
export const SELECTED_STORE = 'SELECTED_STORE';
export const CLICKED_STORE = 'CLICKED_STORE';
export const IS_BOSS_SELECTED = 'IS_BOSS_SELECTED';
export const LATITUDE = 'LATITUDE';
export const LONGITUDE = 'LONGITUDE';
export const ERROR_BOSS = 'ERROR_BOSS';

/* SPEEDY */
export const SET_SPEEDY_ORDER_DETAILS = 'SET_SPEEDY_ORDER_DETAILS';